import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {KMDGameMode} from "../server/KMDGameMode";

export class KMDLogo extends PIXI.Container implements StageLayer {
    private _item: PIXI.spine.Spine;
    private _tl: gsap.core.Timeline;

    constructor() {
        super();
        this.name = "KMDLogo";
        this.init();
    }

    public updateYAsPerMode(mode: string): void {
        let y: number = 40;

        if (mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) {
            y = 46;
        } else if (mode === KMDGameMode.FREESPIN_SUPER || mode === KMDGameMode.FREESPIN_SUPER_AVALANCHE) {
            y = 34;
        }

        this._item.y = y;
    }

    public play(): void {
        this._tl = gsap.timeline();
        this._tl.add(() => {
            this._item.state.setAnimation(0, "Logo_Anim", false);
        });
        this._tl.add(() => {
            this.play();
        }, MathHelper.randomIntInRange(50, 60));
    }

    public stop(): void {
        this._tl.pause();
        this._tl.kill();

        this._item.state.clearTracks();
    }

    public turnOffForCFS(): void {
        this.alpha = 0;
    }

    public transitionForCFS(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this, {
            duration: duration,
            alpha: 1
        });

        return tl;
    }

    private init(): void {
        this._item = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("logo"));
        this._item.position.set(360, 40);
        this._item.scale.set(0.95);

        this.addChild(this._item);
    }
}